import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getPayDues } from '../../../reducers/users';

import './paystubs.css';
import { history } from '../../../configuration/store';

class PayduesList extends React.Component {
    componentDidMount() {
        let { contractorId, getPayDues } = this.props;
        if (contractorId) {
            getPayDues(contractorId);
        }
    }

    goToDetails(id) {
        history.push(`/paydue/${id}`);
    }

    render() {
        const { paydues } = this.props;

        return (
            <div className="row">
                {paydues.map(payDue => {
                    return (
                        <div className="col-xs-12 paystub-item" key={payDue.id}>
                            <div className="row">
                                <div className="col-md-5 col-xs-10" onClick={() => this.goToDetails(payDue.id)}>
                                    <span className="paystub-name">{payDue.name}</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}

PayduesList.defaultProps = {
    paydues: []
};

PayduesList.propTypes = {
    contractorId: PropTypes.string,
    paydues: PropTypes.array
};

const mapStateToProps = state => ({
    paydues: state.users.paydues
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getPayDues
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(PayduesList);



// WEBPACK FOOTER //
// ./src/components/lists/paydues/index.jsx